import { FC } from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';

interface Props {
  visible: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

/**
 * Confirmation shown before the diagnostic widget is hidden from the dashboard.
 * Hiding is a one-way action from the teacher's point of view, so we reassure them
 * that the data is still reachable from Monitor before committing the user action.
 */
const HideDiagnosticWidgetDialog: FC<Props> = ({ visible, onHide, onConfirm }) => {
  return (
    <ConfirmDialog
      tagKey="hide-diagnostic-widget"
      visible={visible}
      onHide={onHide}
      closable={false}
      className="!tw-max-w-[600px]"
      content={({ hide }) => (
        <div className="tw-flex tw-flex-col tw-gap-y-3 tw-p-6 tw-bg-white tw-rounded-2xl">
          <h1 className="tw-text-2xl tw-font-bold tw-font-atkinson tw-text-neutral-950 tw-m-0">
            Done with the diagnostic?
          </h1>

          <p className="tw-text-sm tw-font-atkinson tw-text-neutral-700 tw-m-0">
            You can still track progress under <span className="tw-font-bold tw-text-neutral-950">Monitor</span>, in the{' '}
            <span className="tw-font-bold tw-text-neutral-950">Diagnostic section</span>.
          </p>

          <div className="tw-flex tw-justify-end tw-gap-x-2 tw-mt-2">
            <Button label="Cancel" outlined onClick={e => hide(e)} />
            <Button
              label="Yes, I'm done"
              onClick={e => {
                onConfirm();
                hide(e);
              }}
            />
          </div>
        </div>
      )}
    />
  );
};

export default HideDiagnosticWidgetDialog;
